export const servicesData = {
  recruitment: {
    title: "Recruitment & Hiring Solutions",
    heroDescription:
      "Helping businesses identify, hire, and onboard suitable talent through structured recruitment support and practical hiring processes.",

    overview: [
      "Finding the right employees is an important part of building a productive workforce. Maxzen HR supports businesses with recruitment solutions designed to simplify hiring activities and help organizations fill positions efficiently.",
      "We assist with candidate sourcing, profile screening, shortlisting, interview coordination, and onboarding support, helping businesses reduce hiring challenges and focus on their operational goals.",
    ],

    help: [
      "Candidate Sourcing",
      "Resume Screening",
      "Candidate Shortlisting",
      "Interview Coordination",
      "Hiring Support",
      "Onboarding Assistance",
    ],

    benefits: [
      "Faster Hiring Process",
      "Access to Qualified Candidates",
      "Reduced Recruitment Workload",
      "Better Workforce Planning",
      "Improved Hiring Decisions",
    ],

    process: [
      "Understand Workforce Requirements",
      "Source Suitable Candidates",
      "Screen and Evaluate Profiles",
      "Coordinate Interviews",
      "Assist with Candidate Selection",
      "Support Employee Onboarding",
    ],

    whyChoose: [
      "Structured Recruitment Process",
      "Dedicated Hiring Support",
      "Industry Hiring Experience",
      "Reliable Communication",
      "Focus on Workforce Quality",
    ],

    cta: "Need support with recruitment and hiring?",
  },

  payroll: {
    title: "Payroll Management",
    heroDescription:
      "Managing employee payroll processes in a structured and reliable way to support smooth salary management and daily HR operations.",

    overview: [
      "Managing payroll requires accuracy, consistency, and proper coordination. Maxzen HR helps businesses handle payroll activities efficiently, ensuring employees are paid on time while reducing administrative workload.",
      "Our payroll support services help organizations manage salary processing, employee records, deductions, and payroll-related activities in an organized manner.",
    ],

    help: [
      "Salary Processing",
      "Employee Payroll Records",
      "Attendance & Leave Coordination",
      "Payroll Reporting",
      "Statutory Support",
      "Employee Compensation Management",
    ],

    benefits: [
      "Timely Salary Processing",
      "Reduced Administrative Work",
      "Better Payroll Organization",
      "Improved Record Management",
      "Consistent Payroll Operations",
    ],

    process: [
      "Understand Payroll Requirements",
      "Collect Employee Data",
      "Process Payroll Information",
      "Verify Salary Details",
      "Generate Payroll Reports",
      "Complete Payroll Support Activities",
    ],

    whyChoose: [
      "Structured Payroll Processes",
      "Reliable Payroll Support",
      "Organized Record Management",
      "Professional HR Assistance",
      "Consistent Service Delivery",
    ],

    cta: "Need support with payroll management?",
  },

  workforce: {
    title: "Workforce Outsourcing",
    heroDescription:
      "Providing workforce support solutions that help businesses manage operations, staffing requirements, and day-to-day workforce needs.",

    overview: [
      "Managing workforce requirements can be challenging as businesses grow and operational demands increase. Maxzen HR helps organizations meet staffing needs through workforce outsourcing solutions designed to support business continuity and operational efficiency.",
      "We work with businesses to provide workforce support that helps manage resources, improve productivity, and maintain smooth day-to-day operations.",
    ],

    help: [
      "Workforce Deployment",
      "Staffing Support",
      "Resource Management",
      "Operational Workforce Assistance",
      "Employee Coordination",
      "Workforce Planning Support",
    ],

    benefits: [
      "Flexible Workforce Support",
      "Reduced Operational Burden",
      "Better Resource Utilization",
      "Improved Workforce Management",
      "Scalable Staffing Solutions",
    ],

    process: [
      "Understand Workforce Requirements",
      "Assess Staffing Needs",
      "Identify Suitable Resources",
      "Deploy Workforce Support",
      "Monitor Workforce Performance",
      "Provide Ongoing Workforce Assistance",
    ],

    whyChoose: [
      "Practical Workforce Solutions",
      "Flexible Staffing Support",
      "Industry Understanding",
      "Reliable Workforce Management",
      "Dedicated Client Assistance",
    ],

    cta: "Looking for workforce support solutions?",
  },

  training: {
    title: "Training & Workforce Development",
    heroDescription:
      "Supporting employee growth through practical training programs focused on workplace performance and professional development.",

    overview: [
      "A skilled workforce plays an important role in business success. Maxzen HR helps organizations strengthen employee capabilities through training and workforce development programs designed to support workplace performance and continuous learning.",
      "Our training solutions focus on helping employees improve their skills, adapt to changing work environments, and contribute more effectively to organizational goals.",
    ],

    help: [
      "Employee Training Programs",
      "Workplace Skill Development",
      "Professional Development Support",
      "Soft Skills Training",
      "Workforce Learning Initiatives",
      "Performance Improvement Support",
    ],

    benefits: [
      "Improved Employee Performance",
      "Better Workplace Productivity",
      "Enhanced Professional Skills",
      "Stronger Team Development",
      "Continuous Learning Culture",
    ],

    process: [
      "Understand Training Requirements",
      "Identify Skill Development Areas",
      "Design Training Programs",
      "Conduct Training Sessions",
      "Monitor Learning Outcomes",
      "Support Ongoing Development",
    ],

    whyChoose: [
      "Practical Training Approach",
      "Workforce Development Focus",
      "Industry-Relevant Programs",
      "Employee Growth Support",
      "Professional Training Assistance",
    ],

    cta: "Looking to strengthen your workforce?",
  },

  consulting: {
    title: "HR Consulting & Support",
    heroDescription:
      "Helping businesses improve HR operations, workforce planning, and employee management through practical HR guidance.",

    overview: [
      "Effective HR management is essential for maintaining a productive and organized workplace. Maxzen HR supports businesses with practical HR consulting services that help improve workforce management, employee processes, and day-to-day HR operations.",
      "Our team works closely with organizations to understand workforce challenges and provide guidance that supports better HR practices and business operations.",
    ],

    help: [
      "HR Policy Guidance",
      "Workforce Planning Support",
      "Employee Management Assistance",
      "HR Process Improvement",
      "Organizational Support",
      "Workplace Practice Recommendations",
    ],

    benefits: [
      "Better HR Organization",
      "Improved Workforce Management",
      "Structured Employee Processes",
      "Stronger Workplace Practices",
      "Enhanced Operational Support",
    ],

    process: [
      "Understand Business Requirements",
      "Review Existing HR Practices",
      "Identify Improvement Areas",
      "Recommend Practical Solutions",
      "Support Implementation",
      "Provide Ongoing HR Guidance",
    ],

    whyChoose: [
      "Practical HR Experience",
      "Business-Focused Approach",
      "Reliable HR Support",
      "Structured Workforce Guidance",
      "Dedicated Client Assistance",
    ],

    cta: "Need support with your HR operations?",
  },

  verification: {
    title: "Employee Verification Services",
    heroDescription:
      "Conducting employee background and verification processes to support reliable hiring and workforce transparency.",

    overview: [
      "Verifying candidate information is an important step in the hiring process. Maxzen HR helps businesses conduct employee verification activities to confirm candidate details and support informed hiring decisions.",
      "Our verification services assist organizations in maintaining workforce reliability while reducing hiring risks through structured verification processes.",
    ],

    help: [
      "Identity Verification",
      "Employment Verification",
      "Educational Qualification Checks",
      "Address Verification",
      "Reference Verification",
      "Background Screening Support",
    ],

    benefits: [
      "More Reliable Hiring Decisions",
      "Improved Workforce Transparency",
      "Reduced Hiring Risks",
      "Better Candidate Validation",
      "Greater Confidence During Recruitment",
    ],

    process: [
      "Collect Candidate Information",
      "Review Required Documents",
      "Conduct Verification Checks",
      "Validate Candidate Details",
      "Prepare Verification Reports",
      "Share Verification Findings",
    ],

    whyChoose: [
      "Structured Verification Process",
      "Reliable Information Checks",
      "Professional Verification Support",
      "Confidential Handling of Data",
      "Timely Verification Assistance",
    ],

    cta: "Need employee verification support?",
  },
};

export default servicesData;